import { useState, useRef } from "react"
import "../Css/ButtonUpload.css"

export default function ButtonUpload({ onFileUploaded }) {
  const btnRef = useRef(null)
  const fileInputRef = useRef(null)
  const [isUploading, setIsUploading] = useState(false)
  const baseURL = process.env.REACT_APP_URLBASE

  const handleClick = () => {
    if (isUploading) return

    const btn = btnRef.current
    if (btn) {
      btn.classList.add("animating")
      setTimeout(() => {
        btn.classList.remove("animating")
        // Abrir selector de archivos después de la animación
        fileInputRef.current?.click()
      }, 600)
    }
  }

const handleFileChange = async (e) => {
  const file = e.target.files?.[0];
  if (!file) return;

  setIsUploading(true);
  try {
    const formData = new FormData();
    formData.append("file", file);

    const res = await fetch(`${baseURL}/update/upload`, {
      method: "POST",
      headers: {
        "user-id": getCookieFromDocument("userId") || "",
      },
      body: formData,
      credentials: "include",
    });

    let data = {};
    try {
      data = await res.json();
    } catch {
      
    }

if (res.ok && data.r2Key) {
  showNotification(`Archivo "${file.name}" subido correctamente`, "success");
  if (onFileUploaded) onFileUploaded();
  e.target.value = "";
} else {
  showNotification(data.message || "Error al subir el archivo", "error");
}
  } catch (error) {
    showNotification(error.message || "Error al subir archivo", "error");
  } finally {
    setIsUploading(false);
  }
};

  function getCookieFromDocument(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(";").shift()
    return null
  }

  const showNotification = (message, type) => {
    const notification = document.createElement("div")
    notification.className = `notification ${type}`
    notification.textContent = message

    document.body.appendChild(notification)

    setTimeout(() => {
      notification.classList.add("show")
    }, 10)

    setTimeout(() => {
      notification.classList.remove("show")
      setTimeout(() => {
        document.body.removeChild(notification)
      }, 300)
    }, 3000)
  }

  return (
    <>
      <input ref={fileInputRef} type="file" onChange={handleFileChange} style={{ display: "none" }} accept="*/*" />
      <div className="button-flip-container">
        <div className={`button-circular ${isUploading ? "uploading" : ""}`} ref={btnRef} onClick={handleClick}>
          <div className="front">
            {isUploading ? (
              <div className="upload-spinner"></div>
            ) : (
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
            )}
          </div>
          <div className="back">
            <span>{isUploading ? "..." : "Subir"}</span>
          </div>
        </div>
      </div>
    </>
  )
}
